import React from 'react'
import "./color.css"

function GreenP() {
    var x = localStorage.getItem("percentage protein")
    return (
        <div className = "green__background">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default GreenP
